<template>
  <div>
    <h1>The post with ID: {{ $route.params.id }}</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>
